import React, { useEffect, useState } from "react";
import "./RichFileSelector.css";
import { FileInput } from "../FlowConfigurationInputs";
import { TextInput } from "../FlowConfigurationInputs/TextInput/NewTextInput";
export default function RichFileSelector({
  action,
  variables,
  setOpenVariable,
  options,
}) {
  const [buttonSelect, setButtonSelect] = useState({});


  useEffect(() => {
    if (!action.fields.selectTabs) {
      action.fields.selectTabs = { value: options?.defaultTabValue ? options?.defaultTabValue : {} };
      setButtonSelect(options?.defaultTabValue ? options?.defaultTabValue : {})
    } else {
      setButtonSelect(action.fields.selectTabs.value)
    }
  }, [action, variables]);

  const handleSelectButton = (event, option) => {
    if (action.fields[buttonSelect?.inputName]) {
      action.fields[buttonSelect?.inputName].value = "";
      delete action.fields[buttonSelect?.inputName].byteVale;
    }
    setButtonSelect(option);
    action.fields.selectTabs.value = option;
  };

  return (
    <>
      <div className="rich-file-selector-button-group">
        {options?.tabGroups?.map((option, index) => (
          <button
            disabled={option?.type?.toLowerCase() === "datastore"}
            onClick={(event) => handleSelectButton(event, option)}
            className={`rich-file-selector-button ${buttonSelect?.type === option?.type?.toLowerCase()
                ? "rich-file-selector-button-active"
                : null
              }`}
            key={index}
          >
            {option?.name}
          </button>
        ))}
      </div>
      {buttonSelect?.type?.toLowerCase() === "browse" ? (
        <div className="form-element">
          <FileInput
            action={action}
            inputName={buttonSelect?.inputName}
            options={options.fileInput}
            isRequired={buttonSelect?.isRequired}
            isSize={true}
          />
        </div>
      ) : null}
      {buttonSelect?.type?.toLowerCase() === "variables" ? (
        <div className="form-element">
          <TextInput
            action={action}
            inputName={buttonSelect?.inputName}
            isRequired={buttonSelect?.isRequired}
            variables={variables}
            setOpenVariable={setOpenVariable}
          />
        </div>
      ) : null}
      {buttonSelect?.type?.toLowerCase() === "datastore" ? (
        <div className="form-element">
          {/*  data store design will be added */}

          {/* <TextInput
            action={action}
            inputName="filePath"
            isRequired={option?.isRequired}
            variables={variables}
            setOpenVariable={setOpenVariable}
          /> */}
        </div>
      ) : null}
    </>
  );
}
